import { render, staticRenderFns } from "./class_mode.vue?vue&type=template&id=16f87572&scoped=true"
import script from "./class_mode.vue?vue&type=script&lang=js"
export * from "./class_mode.vue?vue&type=script&lang=js"
import style0 from "./class_mode.vue?vue&type=style&index=0&id=16f87572&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f87572",
  null
  
)

export default component.exports